import { colors } from '@mui/material';
import { Color } from 'antd/es/color-picker';
import styled from 'styled-components';
import { PrimaryColor, TextColor } from 'styles/Global/colorSemantic';
import { Body3Bold } from 'styles/Global/typography';

export default function SectionTitle({ leftTitle, rightTitle }: { leftTitle: string; rightTitle?: string }) {
    return (
        <SectionTitleContainer>
            <Body3Bold>{leftTitle}</Body3Bold>
            {rightTitle && <Body3Bold $color={PrimaryColor.color_primary_normal}>{rightTitle}</Body3Bold>}
        </SectionTitleContainer>
    );
}

const SectionTitleContainer = styled.div`
    display: flex;
    gap: 4px;
`;
